<template>
  <el-form :inline="true" :model="formData" class="search-box">
    <!-- 监管账号 -->
    <div class="select_from_store_name">
      <label-input
        label="门店名称"
        placeholder="请输入门店名称"
        width="334px"
        v-model="formData.drugstore"
        v-if="$checkPower('a,b,c')"
        type="autocomplete"
        :_parent="_self"
      />
    </div>
    <el-form-item class="fl">
      <label-input label="处方费别">
        <el-select v-model="formData.costType" placeholder="请选择处方费别" clearable>
          <el-option :value="0" label="普通处方"></el-option>
          <el-option :value="1" label="门统处方"></el-option>
        </el-select>
      </label-input>
    </el-form-item>

    <el-form-item class="fl" v-if="$checkPower('a,b,c,d,e,f')">
      <label-input label="处方状态">
        <el-select v-model="formData.prescriptionTotalStatus" placeholder="请选择处方状态" clearable>
          <el-option v-for="(t, k) in searchStatus" :key="k" :label="t" :value="k"></el-option>
        </el-select>
      </label-input>
    </el-form-item>

    <el-form-item :key="slotName" class="fl" v-for="(item, slotName) in $slots">
      <slot :name="slotName"></slot>
    </el-form-item>

    <!-- 非监管账号 -->
    <!-- <el-form-item class="fl" v-if="showReAuditPharmacistSource">
      <label-input label="复审药师端">
        <el-select v-model="formData.reAuditPharmacistSource" placeholder="请选择终端类型" clearable>
          <el-option label="APP" value="APP"></el-option>
          <el-option label="PC" value="PC"></el-option>
        </el-select>
      </label-input>
    </el-form-item> -->
    <el-form-item class="fl" v-permission.not="'h,i,j'">
      <label-input label="咨询方式">
        <el-select v-model="formData.advisoryType" placeholder="请选择咨询方式" clearable>
          <el-option v-for="(t, k) in advisoryTypes" :key="k" :label="t" :value="k"></el-option>
        </el-select>
      </label-input>
    </el-form-item>
    <el-form-item class="fl" v-permission.not="'h,i,j'">
      <label-input label="提交人员">
        <zy-select
          class="submit-selector"
          v-model="formData.userIdList"
          multiple
          filterable
          remote
          reserve-keyword
          placeholder="请输入关键词"
          :remote-method="querySubmitter"
        >
          <zy-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></zy-option>
        </zy-select>
      </label-input>
    </el-form-item>
    <el-form-item class="fl" v-permission.not="'h,i,j'">
      <label-input label="处方类型">
        <el-select v-model="formData.prescriptionType" placeholder="请选择处方类型" clearable>
          <el-option v-for="(t, k) in prescriptionType" :key="k" :label="t" :value="k"></el-option>
        </el-select>
      </label-input>
    </el-form-item>
    <el-form-item class="fl">
      <label-input label-width="100px">
        <template #label>
          <span>开方时间</span>
        </template>
        <component :is="{ render: renderDatePicker }"></component>
      </label-input>
    </el-form-item>
    <el-form-item class="fl">
      <label-input label="快捷选择日期" label-width="110px">
        <div class="button-group">
          <div v-for="(item, i) in quickDate" :key="i" class="button" @click="setDate(item.value)">
            {{ item.label }}
          </div>
        </div>
      </label-input>
    </el-form-item>
    <el-form-item class="fl">
      <el-button type="info" plain @click="onSubmit" class="search-btn">查询</el-button>
    </el-form-item>
    <el-form-item class="fl" v-if="$checkPower('a,b,c,d,e,f') && hideExportButton">
      <el-button type="info" plain @click="onExport" class="search-btn">导出</el-button>
    </el-form-item>
    <slot name="button" />
  </el-form>
</template>

<script>
import uniqBy from 'lodash/uniqBy';
import labelInput from '@/components/global/form/labelInput';
import { transformParamToUrl, downloadByIframe } from '@/util';
import Constant from '@/lib/constant';
import dayjs from 'dayjs';
import { dateLimit } from '@/util/mixins';
import fetchApi from '@/api';
import zySelect from './select/src/select';
import zyOption from './select/src/option';

export default {
  name: 'breadTab',
  components: { labelInput, zySelect, zyOption },
  mixins: [dateLimit()],
  props: {
    searchData: {
      type: Object,
      default: () => {
        return {
          patientName: '',
          costType: '',
          date: '',
          prescriptionTotalStatus: '',
          reAuditPharmacistSource: '',
          advisoryType: '',
          prescriptionType: '',
          userIdList: []
        };
      }
    },
    hideExportButton: {
      type: Boolean,
      default: true
    },
    // 是否开启奇葩的时间控件 先定一个自然月内的时间选择
    absurd: {
      type: Boolean,
      default: false
    },
    showReAuditPharmacistSource: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formData: {
        patientName: '',
        costType: '',
        date: [],
        prescriptionTotalStatus: '',
        drugstore: '', // 搜索的药店名称
        reAuditPharmacistSource: '', // 复审药师端
        advisoryType: '',
        prescriptionType: '',
        userIdList: []
      },
      searchStatus: Constant.searchStatus,
      advisoryTypes: Constant.advisoryTypes,
      prescriptionType: Constant.prescriptionType,
      options: [],
      cacheOptions: []
    };
  },
  computed: {
    quickDate() {
      const currentDay = dayjs().startOf('month');

      return [
        {
          label: currentDay.subtract(3, 'month').format('M') + '月',
          value: [
            currentDay.subtract(3, 'month').format('YYYY-MM-DD HH:mm:ss'),
            currentDay.subtract(3, 'month').endOf('month').format('YYYY-MM-DD HH:mm:ss')
          ]
        },
        {
          label: currentDay.subtract(2, 'month').format('M') + '月',
          value: [
            currentDay.subtract(2, 'month').format('YYYY-MM-DD HH:mm:ss'),
            currentDay.subtract(2, 'month').endOf('month').format('YYYY-MM-DD HH:mm:ss')
          ]
        },
        {
          label: currentDay.subtract(1, 'month').format('M') + '月',
          value: [
            currentDay.subtract(1, 'month').format('YYYY-MM-DD HH:mm:ss'),
            currentDay.subtract(1, 'month').endOf('month').format('YYYY-MM-DD HH:mm:ss')
          ]
        }
      ];
    }
  },
  watch: {
    searchData: {
      handler: function (val) {
        this.formData = val;
      },
      deep: true
    }
  },
  created() {
    this.getAdvisoryTypes();
  },
  mounted() {
    if (this.absurd) {
      // 奇葩。无法赋值默认值 会被触发input事件覆盖掉
      // 默认当月1号-现在时间
      setTimeout(() => {
        this.formData.date = [
          dayjs().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
          dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss')
        ];
      });
    }
  },
  methods: {
    onSubmit() {
      this.$emit('search', this.formData);
      this.$store.commit('prescription/SET_SEARCH_DATA', this.formData);
    },
    handleCommand(command) {
      this.formData.prescriptionTotalStatus = command;
    },
    getAdvisoryTypes() {
      Fetch.photo_advisory_right().then(({ photoAdvisoryRightHistoryOrNow }) => {
        if (!photoAdvisoryRightHistoryOrNow) {
          this.advisoryTypes = Object.keys(Constant.advisoryTypes)
            .filter(key => key != '8')
            .reduce((types, key) => ({ ...types, [key]: Constant.advisoryTypes[key] }), {});
        } else {
          this.advisoryTypes = Constant.advisoryTypes;
        }
      });
    },
    renderDatePicker(h) {
      const { absurd } = this;

      const props = {
        value: this.formData.date,
        'range-separator': '-',
        type: 'datetimerange',
        'start-placeholder': '开始时间',
        'end-placeholder': '结束时间',
        'value-format': 'yyyy-MM-dd HH:mm:ss',
        'default-time': ['00:00:00', '23:59:59'],
        clearable: false,
        'popper-class': 'prescription-date-picker'
      };

      const on = {
        input: v => {
          this.formData.date = v;
        }
      };

      if (absurd) {
        Object.assign(props, this.dateProps);
        Object.assign(on, {
          focus: this.resetDateSpot
        });
      }

      return h('el-date-picker', {
        class: {
          // 'zy-date-picker': true
        },
        style: { border: 'none' },
        props,
        on
      });
    },
    onExport() {
      this.onSubmit();
      // 导出数据
      let { patientName, date, drugstore, prescriptionTotalStatus, reAuditPharmacistSource, advisoryType } =
        this.formData;
      let startTime = (date && date[0]) || '';
      let endTime = (date && date[1].replace(/00:00:00/, '23:59:59')) || '';
      const data = {
        startTime: startTime,
        endTime: endTime,
        patientName: patientName || null,
        drugstore: drugstore || null,
        prescriptionTotalStatus: prescriptionTotalStatus || null,
        reAuditPharmacistSource: reAuditPharmacistSource || null,
        advisoryType: advisoryType || null,
        timetip: Date.now()
      };
      Fetch.prescriptionList(data).then(r => {
        console.log(r);
        if (r.totalCount > Constant.exportNum) {
          this.$message({
            message: '此次导出数据超过2万条，请缩小查询范围后导出',
            type: 'error'
          });
          return;
        }
        const baseUrl = `${Util.getGwRoot}drugstore/1.0/export_prescription`;
        const str = transformParamToUrl(data);
        const openUrl = `${baseUrl}?${str}`;
        downloadByIframe(openUrl, '处方数据');
      });
    },
    setFormStoreId(val) {
      this.formData.storeId = val;
    },
    async querySubmitter(query) {
      if (query !== '') {
        const name = query.replace(
          /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[A9|AE]\u3030|\uA9|\uAE|\u3030/g,
          ''
        );
        const result = await fetchApi.querySubmitter({ name });

        /* eslint-disable */
        this.options = uniqBy(
          result?.data?.map(o => ({
            label: `${o.name}${o.mobile ? `(${o.mobile})` : ''}`,
            value: o.userId
          })),
          'value'
        );
      } else {
        this.options = [];
      }
    },
    setDate(date) {
      this.formData.date = date;
    }
  }
};
</script>
<style lang="scss" scoped>
.select_from_store_name {
  float: left;
  margin-right: 16px;
}
.select_from_user_name {
  float: left;
  margin-right: 16px;
  margin-bottom: 16px;
  height: 40px;
}
.fl {
  //float: left;
  //margin-right: 16px;
  //margin-bottom: 16px;
  //height: 40px;
}
.fr {
  float: right;
  margin-right: 16px;
}
.last {
  margin-right: 0;
}
.link {
  width: 176px;
  background: #fff !important;
  color: #bdbdbd !important;
  text-align: left;
  padding: 12px 12px;
  span {
    i {
      float: right;
    }
  }
  &:hover {
    color: #bdbdbd !important;
  }
}
.search-btn {
  background: #1e8dff !important;
  height: 40px !important;
  width: 80px !important;
  color: #1e8dff !important;
  background: #ffffff !important;
  border: 1px solid #1e8dff !important;
  &:hover {
    background: rgba(68, 184, 91, 0.1) !important;
  }
}

.submit-selector {
  /deep/.el-select__tags {
    max-width: 200px !important;
  }
}

.button-group {
  display: flex;
  gap: 10px;
  .button {
    width: 80px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    cursor: pointer;
    &:hover {
      background: #f5f7fa;
    }
  }
}
</style>
<style lang="scss">
.prescription-date-picker {
  .el-picker-panel__footer {
    .el-button--text {
      display: none;
    }
  }
}
</style>
